import styled, { css } from 'styled-components'
import { ModalProps } from 'src/components/common/Modal/index'
import {
  Noto_body1_b16,
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body2_m14,
  Noto_body2_m15,
  Noto_body2_r14,
  Noto_subheading_b18,
} from 'src/styles/fonts/NotoSansKrFonts'
import { useModal } from 'src/provider/ModalContextProvider'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { ButtonOption3 } from 'src/components/common/Button'
import { TelecomType } from 'src/types/api'

const DEFAULT_TITLE = '서비스 안내'
const DEFAULT_CANCEL_TEXT = <>취소</>

const SKT_TITLE = '휴대폰쿠폰지갑은 만 75세 이상 고객님의 안전한 서비스 이용을 위해 아래 사항을 충분히 안내합니다.'

const SKT_CHILDREN = (
  <>
    본 서비스는 월 5,500원(VAT포함)의 유료서비스이며, 복잡한 디지털 조작이 필요할 수 있습니다.
    <br />
    언제든지 해지 가능합니다.
  </>
)

const SKT_CONFIRM = <>계속 진행하기</>
const SKT_CANCEL = <>중단하기</>

const KT_CHILDREN = (
  <>
    수많은 브랜드의 모바일 e-쿠폰을 상시 할인받고, 핫딜/무료쿠폰 등 다양한 혜택을 제공받을 수 있는
    <span style={{ color: '#FF4E4E' }}> 월 5,500원(VAT포함) 유료부가서비스</span>
    입니다.
    <br />
    가입을 진행하시겠습니까?
  </>
)

const KT_CONFIRM = (
  <>
    휴대폰쿠폰지갑
    <br />
    유료가입(월 5,500원)
  </>
)

const VulnerableModal = ({
  onSubmitInternal,
  onCancelInternal,
  telecom,
}: Pick<ModalProps, 'onSubmitInternal' | 'onCancelInternal'> & { telecom: TelecomType }) => {
  const { closeModal } = useModal()

  const handleJoinButtonClick = () => {
    onSubmitInternal()
    closeModal()
  }
  const handleCancelButtonClick = () => {
    onCancelInternal()
    closeModal()
  }

  //LGU+ 유료 휴대폰쿠폰지갑 부가서비스 가입 확인 모달
  if (telecom === 2) {
    return (
      <S.ModalBackGroundWrap>
        <S.ModalWrap>
          <S.LgModalContainer>
            <S.LgTitle>안내사항</S.LgTitle>
            <S.LgHighlight>유료 휴대폰쿠폰지갑 부가서비스 가입 확인</S.LgHighlight>
            <S.LgDescription>
              수많은 브랜드의 모바일 e-쿠폰을 상시 할인받고, 핫딜/무료쿠폰 등 다양한 혜택을 드리며
              [동의]를 누르실 경우, 월 5,500원(VAT포함) 서비스 이용 요금이 부과되는 유료서비스
              입니다.
            </S.LgDescription>
            <S.LgBillingNotice>
              동의 시 통신요금에 서비스 이용요금이 청구됩니다.
            </S.LgBillingNotice>
            <S.LgAgreeButton onClick={handleJoinButtonClick}>동의</S.LgAgreeButton>
            <S.LgCancelButton onClick={handleCancelButtonClick}>취소</S.LgCancelButton>
          </S.LgModalContainer>
        </S.ModalWrap>
      </S.ModalBackGroundWrap>
    )
  }

  let modalTitle = telecom === 0 ? SKT_TITLE : DEFAULT_TITLE
  let modalCancelText = telecom === 0 ? SKT_CANCEL : DEFAULT_CANCEL_TEXT
  let modalChildren: React.ReactNode
  let modalConfirmText: React.ReactNode

  switch (telecom) {
    case 0:
      modalChildren = SKT_CHILDREN
      modalConfirmText = SKT_CONFIRM
      break
    case 1:
      modalChildren = KT_CHILDREN
      modalConfirmText = KT_CONFIRM
      break
    default:
      modalChildren = SKT_CHILDREN
      modalConfirmText = SKT_CONFIRM
      break
  }

  return (
    <S.ModalBackGroundWrap>
      <S.ModalWrap>
        <S.VulnerableModalContainer $option="flex_column" $row_gap="26px">
          <Container $option="flex_column" $row_gap="10px">
            <S.ModalTitle $isMultiLine={telecom === 0}>{modalTitle}</S.ModalTitle>
            <S.ModalContents $isSmallText={telecom === 0}>{modalChildren}</S.ModalContents>
          </Container>
          <Container $option="flex_row_space_between" $column_gap="7px">
          <S.CancelButton onClick={handleCancelButtonClick}>{modalCancelText}</S.CancelButton>
            <S.JoinButton onClick={handleJoinButtonClick} $isSmallText={telecom === 1}>
              {modalConfirmText}
            </S.JoinButton>
          </Container>
        </S.VulnerableModalContainer>
      </S.ModalWrap>
    </S.ModalBackGroundWrap>
  )
}
export default VulnerableModal

const S = {
  ModalBackGroundWrap: styled.div`
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    overflow: hidden;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  `,
  ModalWrap: styled.div`
    width: 100%;
    max-width: 360px;
    min-width: 280px;
    margin: 0 40px;
  `,
  VulnerableModalContainer: styled(Container)`
    align-items: center;
    padding: 26px 24px;
    margin-bottom: 26px;
    border-radius: 24px;
    background: var(--white);
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);
  `,
  ModalTitle: styled(Typography)<{ $isMultiLine: boolean }>`
  ${Noto_subheading_b18};
  ${({ $isMultiLine }) =>
    $isMultiLine &&
    css`
       ${Noto_body1_b16};
    `}
`,
  ModalContents: styled.div<{ $isSmallText: boolean }>`
    ${Noto_body1_r16};
    ${({ $isSmallText }) =>
      $isSmallText &&
      css`
         ${Noto_body2_r14};
      `}
    span {
      color: var(--red-50);
    }
  `,
  CancelButton: styled.button`
    ${ButtonOption3('default')};
  `,
  JoinButton: styled.button<{ $isSmallText: boolean }>`
    ${ButtonOption3('active')};
    ${({ $isSmallText }) =>
      $isSmallText &&
      css`
        font-size: 12px;
        line-height: 14px;
      `}
  `,
  LgModalContainer: styled.div`
    width: 100%;
    padding: 26px 24px;
    background-color: var(--white);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    text-align: center;
  `,
  LgTitle: styled.p`
    ${Noto_subheading_b18};
    margin: 0 0 10px;
  `,
  LgHighlight: styled.p`
    ${Noto_body2_b14};
    color: var(--red-50);
    margin: 0 0 10px;
  `,
  LgDescription: styled.p`
    ${Noto_body2_r14};
    margin: 0 0 10px;
  `,
  LgBillingNotice: styled.p`
    ${Noto_body2_m15};
    color: var(--black-100);
    margin: 0 0 10px;
  `,
  LgAgreeButton: styled.button`
    background: var(--brand-50);
    color: white;
    width: 100%;
    border-radius: 12px;
    padding: 12px;
    ${Noto_body1_b16};
  `,
  LgCancelButton: styled.button`
    width: 100%;
    margin-top: 6px;
    padding: 3px 10px;
    color: var(--black-50);
    ${Noto_body2_m14};
  `,
}
